import { getDatabase, onValue, ref } from 'firebase/database';
import { firebaseApp } from '../../../FirebaseConfig';
import { Currency } from 'src/api/user/data/enums/user-currency.enum';

export async function getExchangeRatesUsecase(): Promise<Record<Currency, number>> {
  return new Promise((resolve, reject) => {
    const db = getDatabase(firebaseApp);
    const contriesRef = ref(db, '/appdata/exchangeRates');

    onValue(contriesRef, (snapshot) => {
      resolve(snapshot.val());
    });
  });
}
